import { getEnvConfig } from "@/config/environments";
import { isDev } from "@/utils/env";
import { Auth } from "@aws-amplify/auth";

export const configureAuth = () => {
  const config = getEnvConfig();

  let redirectSignIn = `https://${config.appEnv.toLowerCase()}.us.canopyservicing.com/app`;
  let redirectSignOut = `https://${config.appEnv.toLowerCase()}.us.canopyservicing.com/signin`;
  if (isDev) {
    redirectSignIn = "http://localhost:3000/app";
    redirectSignOut = "http://localhost:3000/signin";
  } else if (config.APIDomain?.includes("dev.canopy.town")) {
    redirectSignIn = `https://${config.appEnv.replace("-", "-os.")}.dev.canopy.town/app`;
    redirectSignOut = `https://${config.appEnv.replace("-", "-os.")}.dev.canopy.town/signin`;
  }

  const authenticationFlowType = config.authType || "USER_SRP_AUTH";
  Auth.configure({
    Auth: {
      authenticationFlowType,
      region: config.region,
      userPoolId: config.userPoolId,
      userPoolWebClientId: config.cognitoClientId,
      oauth: {
        domain: config.cognitoDomain?.replace(/^https:\/\//, ""),
        scope: ["email", "openid", "profile"],
        redirectSignIn,
        redirectSignOut,
        responseType: "code",
      },
    },
    ssr: true,
  });
};
